<div class="card user-card">
	<div class="card-body text-center">
		<i class="bi bi-x remove" [title]="removeMessage" (click)="crossClicked()"></i>
		<div class="avatar-container">
			<app-avatar [user]="user" [avatarSize]="3"></app-avatar>
		</div>
		<p class="header user-name">{{ user.getName() }}</p>
	</div>
</div>